export default __webpack_public_path__ + "static/media/background-stub.686dc2ae.mp4";